import React, { useEffect } from 'react'
import { useOutletContext } from 'react-router-dom';
import { OutletcontextType } from '../components/Layout/AdminLayout';
import { FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material';
import useDocumentOcrModel, { type DocumentOCRModel } from '../hooks/useDocumentOcrModel';

const Models = [
    {
        label: "Gemini", value: "gemini",
    },
    {
        label: "Opus", value: "opus",
    },
    {
        label: "Qwen", value: "qwen",
    },
    {
        label: "Amazon Bedrock", value: "amazon_bedrock",
    }
]

const DocumentOCRSettings = () => {
    const { handleChangeTitle, showSnackbar } =
        useOutletContext<OutletcontextType>();

    const { ocrModel, updateDocumentOcrModel } = useDocumentOcrModel();

    useEffect(() => {
        document.title = "AiFise | User Management";
        handleChangeTitle(
            "Document OCR Setting",
            "Update Model for Document OCR"
        );
    }, []);

    return (
        <div>
            <Grid container spacing={6}>
                <Grid item xs={12} md={3} sm={6} >
                    <FormControl fullWidth size="medium" sx={{ mb: 2 }}>
                        <InputLabel id="document-type-label">
                            Model Type
                        </InputLabel>

                        <Select
                            labelId="model-type-label"
                            value={ocrModel}
                            label="Select Model"
                            onChange={(e) => updateDocumentOcrModel(e.target.value as DocumentOCRModel)}
                            sx={{
                                backgroundColor: "#fff",
                                borderRadius: "8px",
                                height: "50px",

                                "& .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#d1d5db",
                                },

                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#3b82f6",
                                },

                                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#2563eb",
                                },
                            }}
                        >
                            {
                                Models.map((model, index) => <MenuItem key={model.value + index} value={model.value}>{model.label}</MenuItem>)
                            }
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>

            <style>
                {`.css-1yazjtg-MuiInputBase-root-MuiFilledInput-root{
     background-color:white
  }`}
                {`
    @media (min-width: 1536px) {
      .css-vi59no {
       width: 100%; 

      margin-bottom: 30px;
      }
    }

  `}
            </style>
        </div>
    )
}

export default DocumentOCRSettings